module.exports = __webpack_public_path__ + "media/mediaProfessionals/pink-circle-a280a6f3.png";